/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect } from 'react';
import { set, useForm } from 'react-hook-form';
import { message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from '../../../../../Layout/Footer';
import { RegisterHeader } from '../../../Components/Index';
import applicantsService from '../../../../../Services/applicantsService';
import './pscreenCredentialForm.scss';
import psc from '../../../../../Assets/images/psc_logo.png';
import police from '../../../../../Assets/images/logo.png';
import nig_logo from '../../../../../Assets/images/ng_flag_logo.png';
import CandidateInfo from './CandidateInfo/candidateInfo';
import CredentialForm from './CredentialForm/credentialForm';
import PhysicalForm from './PhysicalForm/physicalForm';
import PscreenHeader from './PScreenHeader/pscreenHeader';
import Invitatiion from './Invitation/invitatiion';

interface CandidateInfoType {
  candidateType: 'General Duty' | 'Specialist';
  specialistField?: string;
  nin: string;
  refNo: string;
  name: string;
  stateOfOrigin: string;
  lga: string;
  dateOfBirth: string;
  age: number;
  gender: 'Male' | 'Female';
}

interface CredentialsScreeningType {
  englishGrade: 'A' | 'B';
  mathsGrade: 'A' | 'B';
  subject3Grade: 'A' | 'B';
  subject4Grade: 'A' | 'B';
  ssceCertYear: string;
  guarantorsForm: 'A' | 'B';
  validNinPrintout: 'A' | 'B';
  birthCertificate: 'A' | 'B';
  lgaStateCertificate: 'A' | 'B';
  tradeTest: 'A' | 'B';
  alterationsOnCert: 'A' | 'B';
  comments: string;
  assessorName: string;
  assessorDate: string;
}

interface FinalEndorsementType {
  teamLeadName: string;
  recommendation: 'A' | 'B';
  comments: string;
  signatureDate: string;
}

interface FormDataType {
  candidateInfo: CandidateInfoType;
  credentialsScreening?: CredentialsScreeningType;
  finalEndorsement?: FinalEndorsementType;
  nin: string;
}

const PScreenCredentialForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRole, setUserRole] = useState<
    'candidate' | 'assessor' | 'teamlead'
  >('candidate');
  const [applicationResults, setApplicationResults] = useState<any>(undefined);
  const [applicationPayment, setApplicationPayment] = useState<any>({
    isQualified: 0,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [isPrintMode, setIsPrintMode] = useState(false);
  const [nin, setNin] = useState<string>('');
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setActiveTab] = useState<'academic' | 'physical' | 'screening4'>('academic');

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<FormDataType>();

  const candidateType = watch('candidateInfo.candidateType');

  // Load candidate data from location state
  useEffect(() => {
    if (location.state) {
      // Set application results and payment from location state
      if (location.state.applicationResults) {
        setApplicationResults(location.state.applicationResults);
      }
      if (location.state.applicationPayment) {
        setApplicationPayment(location.state.applicationPayment);
      }

      // Pre-fill candidate information if available
      if (location.state.candidateData) {
        const data = location.state.candidateData;
        Object.keys(data).forEach((key) => {
          setValue(`candidateInfo.${key}` as any, data[key]);
        });
      }
    }
  }, [location.state, setValue]);

  const onSubmit = async (data: FormDataType) => {
    const nin = data.nin;
    if (!nin) {
      message.error('Please enter your NIN');
      return;
    }
    setLoading(true);
    try {
      const response = await applicantsService.pscreeningCredForm({ nin: Number(nin) }, 4);
      setNin(nin);
      const result = response?.data?.dataset;
      if (result) {
        // Populate form fields with API response
        setApplicationResults({ ...result, photo: response?.data?.photo, qrCode: response?.data?.authQR });
        // console.log('API Response for Candidate Info:', applicationResults);
        calculateAge(result.formData.dob);
        if (result.name) setValue('candidateInfo.name', result.name);
        if (result.refNo) setValue('candidateInfo.refNo', result.refNo);
        if (result.stateOfOrigin) setValue('candidateInfo.stateOfOrigin', result.stateOfOrigin);
        if (result.lga) setValue('candidateInfo.lga', result.lga);
        if (result.dateOfBirth) setValue('candidateInfo.dateOfBirth', result.dateOfBirth);
        if (result.gender) setValue('candidateInfo.gender', result.gender);
        if (result.candidateType) setValue('candidateInfo.candidateType', result.candidateType);
        if (result.specialistField) setValue('candidateInfo.specialistField', result.specialistField);
        setShowForm(true);
        message.success('Candidate information loaded successfully');
      } else {
        message.error(response?.data?.message || 'No record found for this NIN');
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Failed to fetch candidate information. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  //   const dateOfBirth = watch('candidateInfo.dateOfBirth');

  const [ageCalculated, setAgeCalculated] = useState<number | null>(null);
  // Calculate age automatically when DOB changes
  const calculateAge = (dob: string) => {
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      //   setValue('candidateInfo.age', age);
      setAgeCalculated(age);
    }
  }
  //   useEffect(() => {

  //     }
  //   }, [dateOfBirth, setValue]);
  const handlePrint = () => {
    // message.info('Preparing your form for printing...');
    setTimeout(() => {
      window.print();
    }, 600);
  };

  return (
    <Fragment>
      <div className='pscreen-form-page'>
        <RegisterHeader />

       { applicationResults === undefined && <div className="pscreen-cred-request">
                <div className="pscreen-cred-request__hero">
                    <div className="container">
                        <div className="pscreen-cred-request__hero-content">
                            <h1 className="pscreen-cred-request__title text-white">Credentials & Physical Screening Forms & Invitation</h1>
                            <p className="pscreen-cred-request__subtitle">
                               All candidates should follow the instructions provided in this section
                            </p>
                        </div>
                    </div>
                </div>

                <div className="pscreen-cred-request__content mt-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 col-xl-7">
                                <div className="pscreen-cred-request__card">
                                    <div className="pscreen-cred-request__card-header">
                                        <h2 className="pscreen-cred-request__card-title">Preview Your Form</h2>
                                        <p className="pscreen-cred-request__card-description">
                                            Enter your National Identification Number to preview and print your credential form.
                                        </p>
                                    </div>

                                    <form onSubmit={handleSubmit(onSubmit)} className="pscreen-cred-request__form">
                                        <div className="pscreen-cred-request__form-group">
                                            <label htmlFor="refid" className="pscreen-cred-request__label">
                                                <span className="pscreen-cred-request__label-text">National Identification Number (NIN)</span>
                                                <span className="pscreen-cred-request__label-required">*</span>
                                            </label>
                                            <div className="pscreen-cred-request__input-wrapper">
                                                <svg className="pscreen-cred-request__input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                    <circle cx="12" cy="7" r="4"></circle>
                                                </svg>
                                                <input
                                                    id="refid"
                                                    type="text"
                                                    className={`pscreen-cred-request__input ${errors?.nin ? 'pscreen-cred-request__input--error' : ''}`}
                                                    {...register('nin', { required: 'NIN is required' })}
                                                    placeholder="Enter your 11-digit NIN"
                                                    disabled={loading}
                                                    aria-invalid={errors?.nin
                                                      ? "true"
                                                      : "false"}
                                                    aria-describedby={errors?.nin
                                                      ? "nin-error"
                                                      : undefined}
                                                />
                                            </div>
                                            {errors?.nin && (
                                                <div id="nin-error" className="pscreen-cred-request__error" role="alert">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <line x1="12" y1="8" x2="12" y2="12"></line>
                                                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                    </svg>
                                                    <span>{errors.nin.message}</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="pscreen-cred-request__form-actions">
                                            <button type="submit" className="pscreen-cred-request__submit-btn" disabled={loading}>
                                                {loading
                                                  ? (
                                                    <>
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                        <span>Loading...</span>
                                                    </>
                                                    )
                                                  : (
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                            <polyline points="14 2 14 8 20 8"></polyline>
                                                            <line x1="12" y1="18" x2="12" y2="12"></line>
                                                            <line x1="9" y1="15" x2="15" y2="15"></line>
                                                        </svg>
                                                        <span>Preview Form</span>
                                                    </>
                                                    )}
                                            </button>
                                        </div>
                                    </form>

                                    <div className="pscreen-cred-request__help">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <span>Make sure to bring your printed credential form to the physical screening venue.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          </div>}

        {applicationResults !== undefined && <div className='pscreen-container '>
          <div className='pscreen-card'>
            {/* Header */}
            <PscreenHeader psc={psc} police={police} nig_logo={nig_logo} applicationResults={applicationResults} activeTab={activeTab}/>
            <div>
              {/* SECTION A: Candidate Information */}
              <div className='pscreen-section '>
                <div className='py-2'></div>
                <div className='section-header section-header--candidate pt-4 mt-4'>
                  <h2>Section A: Candidate Information</h2>
                  <span className='section-badge'>Candidate</span>
                </div>
                <CandidateInfo applicationResults={applicationResults} nin={nin} ageCalculated={ageCalculated} />
                <div className='text-danger text-center'>  <strong>WARNING!</strong> ANY ALTERATION INVALIDATES THIS FORM
                </div>
              </div>

              {/* WARNING DIVIDER */}
              <div className='warning-divider'>
                <div className='warning-line'></div>
                <div className='warning-text'>
                  <svg
                    className='warning-icon'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                  >
                    <path d='M12 2L1 21h22L12 2zm0 3.5L19.5 19h-15L12 5.5zM11 10v4h2v-4h-2zm0 5v2h2v-2h-2z' />
                  </svg>
                  <strong>WARNING!</strong> Below this line is for Official Use
                  only. Filling of this form by any Candidate and/or
                  unauthorized Officers will lead to outright disqualification.
                </div>
                <div className='warning-line'></div>
              </div>

              {/* Screening Tabs */}
              <div className='screening-tabs'>
                <button
                  type='button'
                  className={`screening-tabs__btn ${activeTab === 'academic' ? 'screening-tabs__btn--active' : ''}`}
                  onClick={() => setActiveTab('academic')}
                >
                  CREDENTIAL SCREENING
                </button>
                <button
                  type='button'
                  className={`screening-tabs__btn ${activeTab === 'physical' ? 'screening-tabs__btn--active' : ''}`}
                  onClick={() => setActiveTab('physical')}
                >
                  PHYSICAL SCREENING
                </button>
                <button
                  type='button'
                  className={`screening-tabs__btn ${activeTab === 'screening4' ? 'screening-tabs__btn--active' : ''}`}
                  onClick={() => setActiveTab('screening4')}
                >
                  INVITATION
                </button>
              </div>

              {/* SECTION B: Academic Screening */}
              {activeTab === 'academic' &&
            <CredentialForm/>
              }

              {/* Physical Screening Tab */}
              {activeTab === 'physical' && <PhysicalForm/>}

              {/* Screening IV Tab */}
              {activeTab === 'screening4' && <Invitatiion applicationResults={applicationResults}/>}

              {/* Instructions and Print Button */}
              <div className='print-instructions no-print'>
                <div className='instruction-box'>
                  <svg
                    className='instruction-icon'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                  >
                    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
                  </svg>
                  <div className='instruction-content'>
                    <h3>Instructions</h3>
                    <ol>
                      {/* <li>
                        Fill in all required fields in{' '}
                        <strong>Section A</strong>
                      </li> */}
                      <li>Click the &quot;Print Form&quot; button below</li>
                      <li>
                        Bring the printed form to your screening venue
                      </li>
                      <li>
                        PSC/NPF officials will complete{' '}
                        <strong>Sections B and C</strong> during screening
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {applicationResults.qrCode && (
                <div style={{ display: 'flex', justifyContent: 'center' }} className='py-4'>
                  <img src={`data:image/png;base64,${applicationResults.qrCode}`} alt="QR Code" style={{ width: '100px', height: '100px' }} />
                </div>
              )}

              <div className='form-actions no-print'>
                <button type='button' onClick={handlePrint} className='btn btn--primary btn--large'>
                  <svg
                    className='btn-icon'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                  >
                    <path d='M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' />
                  </svg>
                  Print Form
                </button>
              </div>
            </div>
          </div>
        </div>}
        <Footer />
      </div>
    </Fragment>
  );
};

export default PScreenCredentialForm
